import { ErrorCode } from "@keystone/contracts/shared";

export const errorCodeMessageKeys: Partial<Record<string, string>> = {
  [ErrorCode.OnboardingNotConfigured]: "onboarding:errors.notConfigured",
  [ErrorCode.AdminRoleNotAssignable]: "users:errors.adminRoleNotAssignable",
  [ErrorCode.OrganizationNotFound]: "organizations:errors.notFound",
  [ErrorCode.OrganizationSlugTaken]: "organizations:errors.slugTaken",
  [ErrorCode.TempAccessGrantNotFound]: "temp-access:errors.grantNotFound",
  [ErrorCode.TempAccessNotRequestable]: "temp-access:errors.notRequestable",
  [ErrorCode.TempAccessAlreadyHasAccess]: "temp-access:errors.alreadyHasAccess",
  [ErrorCode.TempAccessDuplicateRequest]: "temp-access:errors.duplicate",
};
